angular.module "editor", [
  "api"
  "services"
  "modulesSettings"
  "editor.controller"
  "editorEmail.controller"
  "editorForm.controller"
  "editorLesson.controller"
  "editorPanel.controller"
  "editorNavigation.controller"
  "editorNavigationSections.controller"
  "pagesSettings.controller"
  "editor.modulesSettings.controller"
  "editor.fontSettings.controller"
  "alert.controller"
  "create.email.controller"
  "edit.email.controller"
  "create.section.controller"
  "create_favorite.section.controller"
  "edit.link.controller"
  "create.link.controller"
  "update.link.controller"
]



// WEBPACK FOOTER //
// ./src/app/editor/main.coffee